import { IBaseDataParser } from "../../../../vendor_core/core/src/server/parsers/IBaseDataParser";
import ILoginData from "../data/ILoginData";
import { IGameConfig } from "../../../../vendor_core/core/src/server/data/IAuthorizationData";

export default class BBLoginDataParser implements IBaseDataParser<ILoginData> {
    check(data: any): boolean {
        return data.stats && data.sid;
    }

    parse(data: ILoginData): any[] {
        // data.refresh.symbols.push(data.refresh.bonusReel);
        let restoreData = null;
        if(data.refresh) {
            this.parseRestoreData(data.refresh.restoreState);
        }
        const result = {
            balance: data.stats.b,
            currency: data.stats.currency,
            sessionID: data.sid,
            serverGameConfig: this.parseGameConf(data),
            country: data.country,
            denomination: data.betMultiplier,
            coinSize: data.limits.defaultBet,
            coinSizeIndex: data.limits.legalBets.indexOf(
                data.limits.defaultBet
            ),
            creditValues: data.limits.legalBets,
            betMultiplier: 1,
            restoreVersion: restoreData ? restoreData.restoreVersion : 1,
            restoreData,
            betMultipliers: this.parseBetMultipliers(data.limits.legalBets),
            betMultiplierMin: data.limits.legalBets[0] / data.limits.defaultBet,
            betMultiplierMax:
                data.limits.legalBets[data.limits.legalBets.length - 1] /
                data.limits.defaultBet,
            numLines: 1,
        };
        console.log('additionalLog LoginDataParser.parse() : ', result);
        
        return [result];
    }

    parseRestoreData(restoreState: string): any {
        if (restoreState) {
            return JSON.parse(restoreState);
        }
        return null;
    }

    private parseBetMultipliers(bets) {
        let result = [];

        let minBet = Math.min.apply(Math, bets);

        for (let i = 0; i < bets.length; i++) {
            result[i] = bets[i] / minBet;
        }
        return result;
    }

    private parseGameConf(data) {
        let result = {
            paylines: data.config.paylines,
            paytable: data.config.paytable,
        };
        return result;
    }
}
